
jQuery(document).ready(function () {



  jQuery(document).on('click','.rm-extraGift', function(){
        $(this).toggleClass('active');
      });
      
  

  

  if(typeof meta == 'object' && ('page' in meta) && meta.page.resourceId == 127649022295) {
    if (jQuery('.rm-myUsername').length > 0) {
      var newUrl = '/pages/program-odmen-prihlaseny-uzivatel';
  
        if(locale == 'en') {
        var newUrl = '/en/pages/gifts-for-purchase-logged';
        }
        if(locale == 'en') {
        var newUrl = '/en/pages/gifts-for-purchase-logged';
        }
        if(locale == 'sk') {
          var newUrl = '/sk/pages/program-odmien-prihlaseny-uzivatel';
        }
        if(locale == 'hu') {
            var newUrl = '/hu/pages/jutalomprogram-bejelentkezett-felhasznalo';
        }
       if(locale == 'ro') {
            var newUrl = '/ro/pages/program-de-recompense-utilizator-logat';
        }
          
      window.location.href = newUrl;
    }
  }


  $(document).on('click','.modal__close', function(){

    console.log('close');
    
  });

  var i = 1;
  $('.play__button--text').each(function(){

    $(this).closest('section').remove();

    var videoHtml = $(this).closest('.brick__block').find('.video-autoplay-wrapper').html().replace('muted="muted"','').replace('playsinline="true"','controls="true"');
    var modalId = ($(this).data('video-id'));

    console.log(videoHtml, $('div[data-modal-container] .modal:nth-child('+i+')').length);

    $('div[data-modal-container] .modal:nth-child('+i+')').find('.rte__video-wrapper').html(videoHtml);
    var id = $('div[data-modal-container] .modal:nth-child('+i+')').attr('id');
    
       const playerElement = document.querySelector("#"+id);
    console.log(playerElement);
      const videoElement = playerElement.querySelector('video');
      

      // const player = new window.Shopify.Plyr(videoElement);
    

    i++;
});
  
  if(window.innerWidth < 1200) {

      $('.mobile__menu__dropdown').removeClass('sliderule__panel');
    
  }

  jQuery(document).on('click', '.sliderow', function(){

      if(jQuery(this).parent().find('.mobile__menu__dropdown').length) {

          jQuery(this).parent().find('.mobile__menu__dropdown').toggleClass('opened');
        
      }
    
  });

  jQuery(document).on('click', '.edit-cookies', function(){

    $('.cc-revoke').click();
setTimeout(function(){

    $('.cc-settings').trigger('click').click();
    
}, 300);
    
  });

    const urlParams = new URLSearchParams(window.location.search);
    const shareParam = urlParams.get('ref');

  
    if (shareParam != null) {
      const modal = document.getElementById('myModal');
      const span = document.getElementsByClassName('close')[0];
    
      

      jQuery('#modal_content').load('https://shopify.pholub.cz/ramissio/home/sharemodal/'+shareParam, function(){

        modal.style.display = 'block';
        
      });
    
      span.onclick = function() {
        modal.style.display = 'none';
      };
    
      window.onclick = function(event) {
        if (event.target == modal) {
          modal.style.display = 'none';
        }
      };
    }

  
  jQuery(document).on('click', '.form-block-submit-button', function(){
      var discountCode = '10% sleva na první nákup';
      document.cookie = 'discount_code=' + discountCode;
  });

 
        
});



  var ALLOWED_KEYWORDS = [
    'visa',
    'shop pay',
    'shopify pay',
    'mastercard',
    'master',
    'maestro',
    'google pay',
    'apple pay'
  ];

  function isAllowed(label) {
    if (!label) return false;
    label = label.toLowerCase();

    return ALLOWED_KEYWORDS.some(function (keyword) {
      return label.indexOf(keyword) !== -1;
    }); 
  }

  function getIconLabel(icon) {
    var title = icon.querySelector('svg title');
    if (title && title.textContent) return title.textContent;

    var hidden = icon.querySelector('.visually-hidden');
    if (hidden && hidden.textContent) return hidden.textContent;

    return '';
  }

  function filterPaymentIcons() {
    var icons = document.querySelectorAll('.footer__icon--payment');

    icons.forEach(function (icon) {
      var label = getIconLabel(icon);

      if (!isAllowed(label)) {
        icon.remove();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', filterPaymentIcons);
  } else {
    filterPaymentIcons();
  }